/**
 * Загружает и инициализирует Яндекс.Метрику на странице.
 * Скрипт метрики подключается асинхронно и инициализируется с переданным ID счётчика.
 * Если метрика уже загружена, повторная загрузка не происходит.
 *
 * @param {number} counterId - Идентификатор счётчика Яндекс.Метрики.
 *
 * @example
 * // Вызов при старте приложения
 * loadYandexMetrika(93064598);
 */
export function loadYandexMetrika(counterId) {
  if (window.location.hostname === 'dropscapital.com' || window.location.hostname === 'www.dropscapital.com') {
    if (window.ym) return; // Чтобы не подключать дважды

    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for(let j=0; j<document.scripts.length; j++){
        if(document.scripts[j].src === r) return;
      }
      k=e.createElement(t), a=e.getElementsByTagName(t)[0];
      k.async=1; k.src=r; a.parentNode.insertBefore(k,a);
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    window.ym(counterId, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true
    });
  }
}